<template>
  <div class="MechanismMenu">
    <div class="logo">
      <img :src="fullImage($store.state.admin.m_thumb)" alt="">
      <div class="truncate logo-title">{{ $store.state.admin.m_name }}</div>
    </div>
    <Row>
      <Col span="8">
      <Menu theme="dark" ref="menu" style="width: 180px;" :active-name="sel_menu" :open-names="open_names"
        @on-select="SelMenu" accordion>
        <div v-for="(item,index) in menu" :key="index">
          <MenuItem :name="index" v-if="item.children.length == 0" class="flex" :to="'/admin'+item.to_link">
          <i class="iconfont" :class="item.icon" :style="{'color': menu_index == index?'#fff':'#ffffffb3'}"></i>
          <span class="mar-left-5">{{ item.name }}</span>
          </MenuItem>
          <Submenu :name="index" v-else>
            <template #title class="flex">
              <i class="iconfont" :class="item.icon" :style="{'color': menu_index == index?'#fff':'#ffffffb3'}"></i>
              <span class="mar-left-5">{{ item.name }}</span>
            </template>
            <MenuItem :name="index+'-'+indexs" v-if="item.children" v-for="(items,indexs) in item.children"
              :to="'/admin'+items.to_link" :key="indexs">
            <div class="flex">
              <i class="iconfont" :class="items.icon"
                :style="{'color': menu_index+'-'+menu_childer_index == index+'-'+indexs?'#fff':'#ffffffb3'}"></i>
              <span class="mar-left-5">{{ items.name }}</span>
            </div>
            </MenuItem>
          </Submenu>
        </div>
      </Menu>
      </Col>
    </Row>
  </div>
</template>

<script>
  export default {
    name: "MechanismMenu",
    data() {
      return {
        sel_menu: 0, //选中下标
        menu_index: 0, //一级路由选中下标
        menu_childer_index: 0, //下级路由选中下标
        open_names: [], //打开的子目录
        menu: []
      }
    },
    created() {
      this.init()
    },
    methods: {
      init() {
        let _this = this
        this.requestApi('/machine/get_menu', {}).then(
          (res) => {
            if (res.code == 200) {
              _this.menu = res.data
              //获取缓存路由
              let mechan_menu_index = localStorage.getItem('mechan_menu_index')
              //判断是否有缓存
              if (mechan_menu_index) {
                //JSON字符串转对象
                mechan_menu_index = JSON.parse(mechan_menu_index)
                //一级路由下标
                _this.menu_index = mechan_menu_index.menu_index
                //连接name
                let sel_menu = mechan_menu_index.menu_index
                //判断是否有二级路由下标
                if (mechan_menu_index.menu_childer_index) {
                  //二级路由下标
                  _this.menu_childer_index = mechan_menu_index.menu_childer_index
                  //连接二级路由下标name
                  sel_menu += '-' + mechan_menu_index.menu_childer_index
                  //需要打开的子目录
                  _this.open_names.push(Number(_this.menu_index))
                }
                //整体选中name
                _this.sel_menu = sel_menu
              }
              //刷新目录下标选择项
              _this.$nextTick(() => {
                _this.$refs['menu'].updateActiveName()
                _this.$refs['menu'].updateOpened()
              })
            } else {
              _this.alertErr(res.msg)
            }
          }
        )
      },
      //点击路由
      SelMenu(name) {
        if (typeof name == 'string') {
          this.sel_menu = name
          let data = name.split('-')
          this.menu_index = data[0]
          this.menu_childer_index = data[1]
          localStorage.setItem('mechan_menu_index', JSON.stringify({
            'menu_index': data[0],
            'menu_childer_index': data[1]
          }))
        } else {
          this.sel_menu = name
          this.menu_index = name
          this.menu_childer_index = 1
          localStorage.setItem('mechan_menu_index', JSON.stringify({
            'menu_index': name
          }))
        }
      }
    }
  }
</script>

<style scoped>
  .iconfont {
    font-size: 16px;
    color: #ffffffb3;
    margin-right: 0px;
  }

  .MechanismMenu {
    width: 180px;
    position: fixed;
    top: 0;
    left: 0;
    height: 100%;
    overflow-y: auto;
    background: #515a6e;

    z-index: 100;
  }

  .ivu-menu-item-selected {
    color: #fff !important;
    background: #2d8cf0 !important;
    border-bottom: 0px !important;
  }

  .logo {
    /* display: flex; */
    /* align-items: center; */
    padding: 10px;
    cursor: pointer;
    transition: all .2s ease;
  }

  .flex {
    display: flex;
    align-items: center;
  }

  .logo img {
    width: 160px;
    height: auto;
  }

  .logo .logo-title {
    font-size: 18px;
    font-weight: 700;
    transition: all .5s;
    color: #fff;
    line-height: normal;
    /* margin-left: 5px; */
    text-align: center;
  }

  .logo .truncate {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .mar-left-5 {
    margin-left: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public/MechanismMenu.vue